import { useContext, useMemo } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { authContext } from "../../context/authContext";
import Cards from "./Cards";

const CardsWithStripe = () => {
  const { accountId } = useContext(authContext);

  const stripePromise = useMemo(
    () =>
      accountId
        ? loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY, {
            stripeAccount: accountId,
          })
        : null,
    [accountId]
  );

  return <Cards stripePromise={stripePromise} accountId={accountId} />;
};

export default CardsWithStripe;
